import { Dropdown } from 'components/v2/Dropdown'
import { StyledLink } from 'components/v2/Link'
import { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { CopyToClipboard, CopyToClipboardWrapper } from '@10xLabs/react-web/components/CopyToClipboard'
import { GTBookingV2UserAccount } from 'gql/types.generated'
import { phoneNumberFormatter } from 'utils/string'

const Container = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`
const Content = styled.div`
  display: flex;
  row-gap: 16px;
  flex-direction: column;
`
const Row = styled.div`
  display: flex;
  gap: 64px;
`
const Item = styled.div`
  display: flex;
  width: 32px;
`
const Value = styled.div`
  display: flex;
  gap: 16px;
`
const getFullName = (firstName?: string | null, lastName?: string | null): string => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`
  }
  if (firstName) {
    return firstName
  }
  if (lastName) {
    return lastName
  }
  return '-'
}
export const BuyerUserAccountDropdown = ({ userAccount }: { userAccount: GTBookingV2UserAccount }): ReactElement => {
  return (
    <Dropdown
      toggle={
        <StyledLink>
          <FormattedMessage id="buyerDropdown.buyer" defaultMessage="User Account" />
        </StyledLink>
      }
      noPadding
      fitContent
    >
      <Container>
        <Content>
          <Row>
            <Item>
              <FormattedMessage id="buyerDropdown.name" defaultMessage="Name" />
            </Item>
            <Value>{getFullName(userAccount.firstName, userAccount.lastName)}</Value>
          </Row>
          <Row>
            <Item>
              <FormattedMessage id="buyerDropdown.id" defaultMessage="ID" />
            </Item>
            <Value>
              {' '}
              <CopyToClipboardWrapper>
                <div>{userAccount.id.substring(0, 8)}</div>
                <CopyToClipboard str={userAccount.id} />
              </CopyToClipboardWrapper>
            </Value>
          </Row>
          <Row>
            <Item>
              <FormattedMessage id="buyerDropdown.email" defaultMessage="Email" />
            </Item>
            <Value>{userAccount.email ? userAccount.email : '-'}</Value>
          </Row>
          <Row>
            <Item>
              <FormattedMessage id="buyerDropdown.phone" defaultMessage="Phone" />
            </Item>
            <Value>
              {userAccount.phoneNumber
                ? phoneNumberFormatter(userAccount.phoneNumber?.number, userAccount.phoneNumber?.countryCode)
                : '-'}
            </Value>
          </Row>
        </Content>
      </Container>
    </Dropdown>
  )
}
